module.exports = __webpack_public_path__ + "img/edit-pencil-new-brand.b8ef4a2d.svg";